// extracted by mini-css-extract-plugin
export default {"newBlog":"list_newBlog__cGuh4","filterSlect":"list_filterSlect__ta0Uk","blogImage":"list_blogImage__AF7y9"};